import { useState } from 'react';
import ModelDeleteDialog from './ModelDeleteDialog';
import ModelActionIcon from './ModelActionIcon';

export default function ModelProvaActions({ models, name, label, open, onToggle }) {
    const [deleting, setDeleting] = useState(false);
    return <>
        <details className="model-folder-menu eliminar-prova-boto" open={open} onToggle={e => onToggle?.(e.currentTarget.open)}>
            <summary aria-label={`Accions de la pinya ${label}`}>•••</summary>
            <div>
                <button disabled={models.busy || !models.data} onClick={async () => {
                    try { await models.mutate('proves/archive', { name }); }
                    catch (_) { /* The model browser displays the error. */ }
                }}><ModelActionIcon action="archive" /><span>Arxiva</span></button>
                <button className="model-folder-danger-text" disabled={models.busy || !models.data} onClick={() => setDeleting(true)}><ModelActionIcon action="delete" /><span>Elimina definitivament…</span></button>
            </div>
        </details>
        {deleting && <ModelDeleteDialog models={models} target={{ kind: 'prova', name }} name={label} onClose={() => setDeleting(false)} />}
    </>;
}
